import { connect } from 'react-redux'
// import moment from 'moment'

import { actions } from 'appRedux/modules/Dashboard'
import { actions as actionsFavorite } from 'appRedux/modules/Favorite'
import { actions as actionsPayment } from 'appRedux/modules/Payment'
import { actions as actionsStock } from 'appRedux/modules/Stock'
// import { actions as actionsStock5GList } from 'appRedux/modules/Stock5GList'

import { AuthRedirect } from 'components'
import Dashboard from './Dashboard'


const mapStateToProps = (state, ownProps) => {
	const { loading, cache, failed } = state.Dashboard;

	let { labID, affiliatedID }	= ownProps.match.params;

	labID = isNaN(labID) ? labID : Number(labID);
	affiliatedID = isNaN(affiliatedID) ? affiliatedID : Number(affiliatedID);

	let currentLabID = affiliatedID ? affiliatedID : labID;

	const labFromCache = (cache[labID]
			// && moment().isBefore(moment(cache[labID].time))
		) ? cache[labID].data
			: null;
	const currentLabFromCache = (cache[currentLabID]
			// && moment().isBefore(moment(cache[currentLabID].time))
		)
			? cache[currentLabID].data : null;

	if (currentLabFromCache) {
		if (isNaN(currentLabID)) { currentLabID = currentLabFromCache.id; }

		if (currentLabFromCache.available === 1) {
			currentLabFromCache.products.forEach((d) => {
				d.single_options = d.single_options
					?
					(typeof d.single_options === 'string'
						?
						JSON.parse(d.single_options)
						:
						d.single_options)
					:
					{}
			});
		}
	}

	return {
		current_fav_group: state.Favorite.current_group,
		is_delete_all_fav_stocks: state.Favorite.is_delete_all,

		is_loading: loading,
		loadLabFailed: failed,
		labID: labID,
		lab: labFromCache,
		affiliatedID: affiliatedID,
		currentLabID: currentLabID,
		currentLab: affiliatedID ? currentLabFromCache : labFromCache,
		// labUseCache        			 : labFromCache !== false,
		// currentLabUseCache 			 : currentLabFromCache !== false,

		stock: state.Stock.select_stock,
		stock_info: state.Stock.stock_info,

		// stock_5g_list: state.Stock5GList.stock_5g_list,
		stock_tw_pool: state.Stock.stock_tw_pool,
	}
};
const mapDispatchToProps = (dispatch) => ({
	onLabDataLoadRequest      	: (labID) => dispatch(
		actions.loadLabDataRequest(labID, false)
	),
	onCurrentLabDataLoadRequest : (lab, affiliated) => dispatch(
		actions.loadCurrentLabDataRequest(lab, affiliated, false)
	),
	// onCurrentLabSet       			: (lab) => dispatch(actions.setCurrentLab(lab)),
	onReset            			  	: () => dispatch(actions.reset()),

	onFavGroupDataLoad     			: () => dispatch(
		actionsFavorite.loadFavGroupDataRequest()
	),
	onFavGroupAllStocksDelete 	: (idx) => dispatch(
		actionsFavorite.deleteFavGroupAllStocksRequest(idx)
	),

	onPaymentProductSet 				: (product) => dispatch(
		actionsPayment.setProduct(product, null)
	),

	onStockInfoLoad					  	: (stockCode) => dispatch(
		actionsStock.loadStockInfoRequest(stockCode)
	),
	onStockSet          				: (stock) => dispatch(
		actionsStock.setStock(stock)
	),

	// onStock5GListLoad     			: () => dispatch(
	// 	actionsStock5GList.loadStock5GRequest()
	// ),
});


export default AuthRedirect.isAuth(connect(mapStateToProps, mapDispatchToProps)(Dashboard))
